module.exports = __webpack_public_path__ + "img/1513050768.4320c26e.jpg";